export const windowModalTitle = "How We Count Windows";
export const windowModalLink = "How We Count Windows?";
export const SelecteServices = "Selected Services:";
export const NumberInputRegex = /[^0-9.]/g;
export const checkBoxGroupType = "checkboxgroup";
export const WDG_FORM_VALUES_HOW_YOU_COUNT_SQFT_KEY = "howManyWindows-sqft";
export const WDG_PROPERTY_FLOORS = "holidayLighting-property-floors";
export const WDG_HOLIDAY_LIGHTING_PROPERTY_SIZE = "holidayLighting-sqft";
export const WDG_PROPERTY_SIZE = "property-size";
export const WDG_GUTTER_PROPERTY_SIZE = "gutter-cleaning-property-size";
export const tooltipIcon = `${window.location.origin}/brand/_assets/images/wdg-info.svg`;
export const QuoteEstimateTitle = "Window Genie™ Quote Estimate";
export const QuoteExemptedServices = "service(s) excluded from estimate: ";
export const PRESSURE_WASHING_ID = "pressure-washing";
export const PRESSURE_WASHING_FIELD_IDS = "pressure-washing-services";
export const HOLIDAY_LIGHTING_ID = "holiday-lighting";
export const HOLIDAY_LIGHTING_PACKAGE_ID = "holidayLighting-package-details";
export const WINDOW_TINTING_ID = "window-tinting";
export const SERVICE = "SERVICE";
export const PRICE = "PRICE";
export const PriceQuoteSummary =
  "The quoted price is an estimate and not a final invoice. On the day of your service appointment, our service professional will recount the windows as listed on the website and/or measure the area for actual size. The final price will be adjusted up or down based on actual counts and / or sizes. Applicable taxes will be applied.";

export const typesOfWindows = [
  "One Window",
  "Two Windows",
  "Three Windows",
  "Specialty Windows",
];
export const landingPageOfferSource = "opus 2 campaign page template";
export const REMOVE_SERVICE_BUTTON_TEXT = "Yes, remove it.";

export const KEEP_SERVICE_BUTTON_TEXT = "No, keep it.";

export const REMOVE_SERVICE_MODAL_TITLE =
  "Are you sure you want to remove this service?";

export const TECH_AVAILABLITY_GRADE_RED = "red";

export const DASH_FOR_PRICE_QUOTE_FIELDS = "--";

export const howWeCountWindowModal = {
  oneWindow: [
    {
      name: "Single Hung Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/single-hung-window.webp",
    },
    {
      name: "Double Hung Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/double-hung-window.webp",
    },
    {
      name: "Plate Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-window-rectangle.webp",
    },
    {
      name: "Plate Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/plate-window.webp",
    },
    {
      name: "Transom Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/transom-window.webp",
    },
    {
      name: "Hexagon/Octagon",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-plate-window-hexagon.webp",
    },
    {
      name: "Suspended Grids/False Grids",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-suspended-grids-false-grids.webp",
    },
    {
      name: "Removable Grids",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-removeable-grids.webp",
    },
    {
      name: "Glider and Sliding Glass Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-sliding-glass-doors.webp",
    },

    {
      name: "Awning, Hopper, Projected Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/hopper-windows.webp",
    },
    {
      name: "Casement Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/casement-window.webp",
    },
  ],
  twoWindows: [
    {
      name: "Two Single/Double Hung Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-image-2-single-double-hung-windows.webp",
    },
    {
      name: "Single Windows With Transom",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-single-window-with-transom-window.webp",
    },
    {
      name: "Sliding Glass Doors",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/sliding-glass-doors.webp",
    },
    {
      name: "French Doors",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/french-doors.webp",
    },
    {
      name: "Fixed/Non-Removable Grids",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/non-removable-grids.webp",
    },
    {
      name: "Two Casement Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/casement-window-two.webp",
    },
  ],
  threeWindows: [
    {
      name: "Three Double Hung Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-double-hung-windows.webp",
    },
    {
      name: "Bay Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/bay-window.webp",
    },
    {
      name: "Storm Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-storm-windows.webp",
    },
  ],

  specialityWindows: [
    {
      name: "Garden Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/garden-window.webp",
    },
    {
      name: "Skylights",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/wdg-skylights.webp",
    },
    {
      name: "Jalousie Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/jalousie-window.webp",
    },
    {
      name: "Glass Block Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/glass-block-windows.webp",
    },
    {
      name: "Stained or Leaded Windows",
      image:
        "https://www.windowgenie.com/us/en-us/_assets/images/how-we-count-windows-images/stained-glass-windows.webp",
    },
  ],
};

export const carouselSettings = {
  dots: true,
  infinite: false,
  speed: 500,
  slidesToShow: 3,
  slidesToScroll: 3,
  initialSlide: 0,
  responsive: [
    {
      breakpoint: 1024,
      settings: { slidesToShow: 2, slidesToScroll: 1 },
    },
    {
      breakpoint: 600,
      settings: { slidesToShow: 1, slidesToScroll: 1 },
    },
  ],
};

export const windowsMapping = {
  0: howWeCountWindowModal.oneWindow,
  1: howWeCountWindowModal.twoWindows,
  2: howWeCountWindowModal.threeWindows,
};
